var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "online-preview-dialog",
      attrs: {
        bodyStyle: { bodyStyle: 0 },
        "append-to-body": "",
        center: "",
        title: _vm.name,
        visible: _vm.dialogVisible,
        width: "100vw",
        top: "0px",
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "online_preview_container" }, [
        _c("iframe", {
          ref: "iframe",
          staticStyle: { width: "100%", height: "calc(100% - 5px)" },
          attrs: {
            width: "100%",
            src: _vm.src,
            frameborder: "0",
            scrolling: "auto",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }